import { FormattedMessage } from 'react-intl'
import { useQueryData, useRunQuery } from '@hooks/useQuery'
import {
  getRelativeTimeProps,
  formatRelativeTimeShort
} from 'src/utils/dateUtils'
import RunButton from '@components/RunButton/RunButton'

interface ChartHeaderRightProps {
  queryId: string
}

export default function ChartHeaderRight({ queryId }: ChartHeaderRightProps) {
  const { lastRun } = useQueryData(queryId)
  const { refreshQueryData } = useRunQuery()
  const lastRunProps = lastRun ? getRelativeTimeProps(lastRun) : null

  return (
    <>
      <div className="last-run">
        <span className="icon icon-verify" />
        <span>
          {lastRunProps ? (
            formatRelativeTimeShort(lastRunProps)
          ) : (
            <FormattedMessage id="never" />
          )}
        </span>
      </div>
      <RunButton
        mini
        id={queryId}
        onSuccess={() => refreshQueryData(queryId)}
      />
    </>
  )
}
